export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const SIGN_IN = baseURL + "/api/auth/signin";
export const SIGN_UP = baseURL + "/api/auth/signup";
export const MENU = baseURL + "/menu";
export const MENU_USER = baseURL + "/menu/v1/users";
// Menu API
export const MENU_ALL = baseURL + "/menu/v1/all";
export const MENU_FIND = baseURL + "/menu/v1/find";
export const MENU_ASSIGNMENT = baseURL + "/menu/v1/manage/assignment";

export const EMPLOYEE_LIST = baseURL + "/user";
export const GET_ALL_EMPLOYEES_LIST = baseURL + "/user/get/allUserDetails";
export const GET_EMPLOYEE_PROFILE_FIELDS = baseURL + "/user/profile-fields";
export const GET_EMPLOYEE_PROFILE_BY_EMPID = baseURL + "/user/v2";
export const GET_ALL_EMPLOYEES_NAME = baseURL + "/user/emp-directory/filter";

export const USER_PROFILE = baseURL + "/user/profile";
export const API_USER_SHIFTS = baseURL + "/user/shifts";

// export const LEAVE_LIST = baseURL + "/leave";
export const LEAVE_LIST = baseURL + "/api/v2/leaves/employee";
// export const APPLY_LEAVE = baseURL + "/leave/leaveApply";
export const APPLY_LEAVE = baseURL + "/api/v2/leaves/apply";
export const APPLY_LEAVE_US = baseURL + "/leave/us/leaveApply";
export const LEAVE_TYPE = baseURL + "/leave/types";
export const LEAVE_BALANCE = baseURL + "/leave/masterleave";
export const LEAVE_APPROVER = baseURL + "/leave/leave/approver";
export const GET_LEAVE_REQUEST_HISTORY =
  baseURL + "/api/v2/leaves/ledger/history";
// export const LEAVE_TYPE_V2 = baseURL + "/leave/v2/types";
export const LEAVE_TYPE_V2 = baseURL + "/api/v2/leaves/allowed-types";
export const LEAVE_APPROVE_HR = baseURL + "/leave/leave/approver/hr";
export const GET_LEAVE_REQUESTS_APPROVE_HR = baseURL + "/api/v2/leaves/hr";
export const LEAVE_BULK_APPROVE_HR = baseURL + "/leave/leave/bulk/approver/hr";
// export const LEAVE_APPROVE_MANAGER = baseURL + "/leave/leave/approver/manager";
export const API_GET_LEAVE_MANAGER_REQUESTS =
  baseURL + "/api/v2/leaves/manager";
export const LEAVE_APPROVE_MANAGER = baseURL + "/api/v2/leaves";
export const LEAVE_APPROVE_MANAGER_SQE = baseURL + "/api/v1/sqe/hr";

export const LEAVE_APPROVE_MANAGER_US = baseURL + "/leave/us/leave/approve";
export const API_LEAVE_WITHDRAW = baseURL + "/api/v2/leaves/withdraw";
export const API_LEAVE_WITHDRAW_US = baseURL + "/leave/us/leave/withdraw";
export const APPLY_LEAVE_SQE = baseURL + "/api/v1/sqe/apply";
export const API_LEAVE_APPROVE_SQE = baseURL + "/api/v1/sqe";
export const API_LEAVE_WITHDRAW_SQE = baseURL + "/api/v1/sqe/withdraw";
export const API_MY_ATTANDANCE = baseURL + "/leave/emp/attandance";
export const API_EXPORT_ATTANDANCE = baseURL + "/leave/export/attandance";
export const API_DOWNLOAD_LEAVE_REPORT = baseURL + "/leave/export/excel";

export const API_LEAVE_APPLY_OOD = baseURL + "/leave/ood/leaveApply";
export const API_LEAVE_GET_USER_OOD = baseURL + "/leave/ood/user/list";
export const API_LEAVE_GET_DL_OOD = baseURL + "/leave/ood/approver/dl";
export const API_LEAVE_GET_HR_OOD = baseURL + "/leave/ood/approver/hr";
export const API_LEAVE_GET_HR_OOD_V2 = baseURL + "/api/timesheets/fully-approved";
export const API_LEAVE_GET_HR_OOD_V2_ACTION = baseURL + "/api/timesheets/hr-update";

//This API is only for getting the list of DL
export const API_LEAVE_GET_OOD_DL_LIST = baseURL + "/leave/ood/dl/list";

export const API_LEAVE_TODAY = baseURL + "/leave/emp/today";
export const API_POLICY = baseURL + "/policy";
export const API_POLICY_V2 = baseURL + "/policy/all";
export const API_POLICY_REGIONS = API_POLICY + "/regions";
export const API_VALIDATE_TOKEN = baseURL + "/api/auth/validate";
export const GET_ONBOARDING_EMPLOYEE_LIST = baseURL + "/onboarding";
export const GET_INVITATION_ONBOARDING_EMPLOYEE_LIST =
  baseURL + "/onboarding/invitations";

export const GET_ONBOARDING_EMPLOYEES_NAME_LIST =
  baseURL + "/onboarding/employees/name";
export const GET_ONBOARDING_CONTACTS =
  baseURL + "/onboarding/onboarding-contacts";
export const GET_ONBOARDING_EMPLOYEE_LIST_PAGINATION =
  baseURL + "/onboarding/paged";
export const GET_EMPLOYEE_LIST = baseURL + "/user";
export const GET_DEPARTMENT_LIST = baseURL + "/onboarding/departmentlist";
export const GET_DESIGNATION_LIST = baseURL + "/onboarding/designationlist";
export const UPDATE_CC_EMAIL = baseURL + "/onboarding/updateEmail";
export const API_UPDATE_EMPLOYEE = baseURL + "/onboarding/update";
export const API_USER_UPDATE_EMPLOYEE = baseURL + "/user/profile/update";

// V2 APIs
export const API_V2_UPDATE_CC_EMAIL = baseURL + "/onboarding/v2/updateEmail";

export const UPLOAD_USER_PHOTO = baseURL + "/user/photo";
export const ADMIN_UPLOAD_USER_PHOTO = baseURL + "/user/admin/photo/upload";
export const API_PROMOTE_EMPLOYEE = baseURL + "/user/employees";
export const API_PERFORMANCE_EMPLOYEE = baseURL + "/performance/employee";
export const API_PERFORMANCE = baseURL + "/performance";
export const API_PERFORMANCE_Evaluation = baseURL + "/performance/hr";
export const API_PERFORMANCE_POINTS = baseURL + "/performance/points";
export const API_PERFORMANCE_VIEW = baseURL + "/performance/view";
export const API_PERFORMANCE_EXPORT = baseURL + "/performance/export";
export const API_PERFORMANCE_SUBMIT = baseURL + "/performance/submit";
export const API_GET_PERFORMANCE = baseURL + "/performance/data";
export const API_GET_PERFORMANCE_EMPLOYEE_LIST =
  baseURL + "/performance/employee/data";
export const API_EVALUATE_PERFORMANCE = baseURL + "/performance/evaluator";
export const API_GET_EVALUATED_PERFORMANCE =
  baseURL + "/performance/evaluator/data";
export const API_EXPORT_PERFORMANCE_EVALUATION =
  baseURL + "/performance/data/export";

export const API_PROBATION_ACTIVE_CYCLE = baseURL + "/probation/active-cycle";
export const API_PROBATION_QUESTIONS = baseURL + "/probation/questions";
export const API_PROBATION_SAVE = baseURL + "/probation/save";
export const API_PROBATION_SUBMIT = baseURL + "/probation/submit";
export const API_PROBATION_CYCLES = baseURL + "/probation/cycles";

export const API_ASSET_TYPES = baseURL + "/assest/owner/types";
export const ASSIGN_ASSET = baseURL + "/assest";
export const ALLOCATE_ASSET = baseURL + "/assest/allocate";
export const ASSET_LIST = baseURL + "/assest/availableAssest";
export const DEALLOCATE_ASSET = baseURL + "/assest/deallocate";
export const DEALLOCATED_ASSETS = baseURL + "/assest/deallocated-assets";
export const API_DEALLOCATE_ACCESS_REQUESTS =
  baseURL + "/api/access/requests/employee";
export const API_ACCESS_DEALLOCATE_REQUEST = baseURL + "/api/access/deallocate";
export const ASSET_TYPE_LIST = baseURL + "/assest/list";
export const CREATE_ASSET = baseURL + "/assest/new";
export const API_BULK_CREATE_ASSET = baseURL + "/assest/bulk/new";
export const API_CREATE_ASSET_TYPE = baseURL + "/assest/create/category";
export const API_APPROVE_ASSET_TYPE_REQUESTS =
  baseURL + "/assest/approve/category";
export const API_ASSET_TYPE_REQUESTS = baseURL + "/assest/category";
export const API_TOTAL_ASSET = baseURL + "/assest/total";
export const API_REQUEST_ASSET = baseURL + "/assest/requestAssest";
export const API_REQUEST_ASSET_LIST = baseURL + "/assest/assestRequestList";
export const API_REQUEST_ACCESS_LIST =
  baseURL + "/api/access/requests/employee";
export const API_APPROVE_REQUEST = baseURL + "/assest/approveRequest";
export const API_ASSET_EXPORT = baseURL + "/assest/export";
export const API_APPROVER_ASSEST_REQUEST_LIST =
  baseURL + "/assest/approverAssestRequestList";
export const API_ASSET_USER = baseURL + "/assest/my";
export const API_ASSET = baseURL + "/assest";

export const API_EXPERIENCE = baseURL + "/experience";

export const API_EMPLOYEE_EDUCATION = baseURL + "/education";
export const API_EMPLOYEE_DEPENDENT = baseURL + "/dependent";
export const API_EMPLOYEE_DOCUMENT = baseURL + "/document";
export const API_EMPLOYEE_TECH_STACK_MASTER =
  baseURL + "/api/employee/tech-stack/master";
export const API_EMPLOYEE_TECH_STACK =
  baseURL + "/api/employee/tech-stack";
export const API_EMPLOYEE_CERTIFICATION =
  baseURL + "/api/employee/certification";
export const API_MY_EMPLOYEE_CERTIFICATIONS =
  baseURL + "/api/employee/certification/me";
export const API_EMPLOYEE_CERTIFICATION_MASTER =
  baseURL + "/api/employee/certification/master";
export const API_EMPLOYEE_CERTIFICATION_LIST =
  baseURL + "/api/employee/certification/list";
export const API_DOCUMENT_STATUS = baseURL + "/document/v1/list/status";
export const API_DOCUMENT = baseURL + "/document";
export const API_DOCUMENT_VERSION = baseURL + "/document/v2/upload";
export const API_DOCUMENT_LIST_APPROVER =
  baseURL + "/document/v1/list/for-approver";
export const API_DOCUMENT_APPROVER = baseURL + "/document/v1/approve";
export const API_GET_DOCUMENT = baseURL + "/document/file";
export const API_GET_EMPLOYEE_FILE = baseURL + "/document/basic/file";
export const API_GET_APPRAISAL_DOCUMENT = baseURL + "/document/appraisal/doc";

export const API_SALARY = baseURL + "/salary";
export const API_UPLOAD_SALARY = baseURL + "/salary/salaryupload";
export const API_DOWNLOAD_SALARY = baseURL + "/salary/downloadFile";

export const API_FORGOT_PASSWORD = baseURL + "/password";
export const API_VERIFY_OTP = baseURL + "/password/verifyOTP";
export const API_CHANGE_PASSWORD = baseURL + "/newPassword";
export const API_RESET_PASSWORD = baseURL + "/password/changePassword";

export const API_REIMBURSEMENT = baseURL + "/reimbursement";
export const API_APPROVE_REIMBURSEMENT_LIST =
  baseURL + "/reimbursement/getApproveReimbursementList";
export const API_REIMBURSEMENT_LIST =
  baseURL + "/reimbursement/reimbursementList";
export const API_EMPLOYEE_REIMBURSEMENT_LIST = baseURL + "/reimbursement/list";
export const API_GET_REIMBURSEMENT_TYPES = baseURL + "/reimbursement/types";

export const API_APPROVE_REIMBURSEMENT =
  baseURL + "/reimbursement/approvereimbursement";
export const API_REIMBURSEMENT_WITHDRAW =
  baseURL + "/reimbursement/withdrawReimbursement";
export const API_REIMBURSEMENT_EXPORT = baseURL + "/reimbursement/export";
export const API_REIMBURSEMENT_BULK_UPLOAD =
  baseURL + "/reimbursement/reimbursements/upload";

export const API_PUNCH = baseURL + "/punch";
export const API_RAISE_CONCERN = baseURL + "/leave/raise/concern";
export const API_GET_RAISED_REQUESTS = baseURL + "/leave/all/concernRequest";
export const API_DOWNLOAD_RAISED_CONCERNS_REPORT =
  baseURL + "/leave/concerns/report";
export const API_GET_RAISED_CONCERNS_BY_EMPLOYEE =
  baseURL + "/leave/concerns/me";

export const API_GET_RAISED_CONCERN_EMPLOYEES_NAME =
  baseURL + "/leave/raise/concern/employees";
export const API_APPROVE_RAISED_CONCERN = baseURL + "/leave/concern/action";
export const API_BULK_APPROVE_RAISED_CONCERN =
  baseURL + "/leave/concern/action/bulk ";
export const API_ANNOUNCEMENT_DASHBOARD =
  baseURL + "/announcement/dashboard/list";

export const API_ROLE = baseURL + "/roles";

export const API_UPLOAD_APPRAISAL = baseURL + "/appraisal/upload";
export const API_APPRAISAL = baseURL + "/appraisal";
export const API_APPRAISAL_V2 = baseURL + "/api/v2/appraisal";
export const API_DOWNLOAD_APPRAISAL = baseURL + "/appraisal/downloadFile";

export const API_FORM16 = baseURL + "/form16";
export const API_FORM16_DOWNLOAD = baseURL + "/form16/downloadFile";

export const API_ROLE_MAPPING = baseURL + "/roles/mapping";
export const API_ROLE_MAPPING_USER = baseURL + "/roles/mapping/v1/user";

export const API_GET_EMAIL_REQUEST = baseURL + "/adhoc/email/list";
export const API_CREATE_EMAIL_REQUEST = baseURL + "/adhoc/email/create";
export const API_UPDATE_EMAIL_REQUEST = baseURL + "/adhoc/email/update";

export const API_UPDATE_EMPLOYEE_TYPE =
  baseURL + "/user/v1/employment-type/update";
export const API_UPDATE_EMPLOYEE_ACCESS = baseURL + "/user/v1/access/update";
export const API_ACCESS_EMPLOYEE_DATA =
  baseURL + "/api/access/accessesEmployeesData";

export const API_DOWNLOAD_ACCESS_REPORT = baseURL + "/api/access/report/export";

export const GET_ASSET_REQUEST_EMP_NAMES = baseURL + "/assest/employees/name";
export const API_V2_APPROVER_ASSEST_REQUEST_LIST =
  baseURL + "/assest/v2/approverAssestRequestList";

export const API_V2_APPROVE_REQUEST = baseURL + "/assest/v2/approveRequest";

export const API_USER_ROLE = baseURL + "/user/with-roles";

export const API_V1_TOTAL_ASSET = baseURL + "/assest/v1/list-all";
export const API_ASSET_RETURN = baseURL + "/asset/return/upload";
export const API_ASSET_RETURNED_LIST = baseURL + "/asset/return/list";
export const API_ASSET_FILTER_TOTAL = baseURL + "/assest/filter/total";

export const API_ANNOUNCEMENT = baseURL + "/announcement";
export const API_ANNOUNCEMENT_UPDATE = baseURL + "/announcement/update";
export const API_ANNOUNCEMENT_ATTACHMENT = baseURL + "/announcement/attachment";

export const API_CREATE_DEPARTMENT = baseURL + "/department/create";
export const API_UPDATE_DEPARTMENT = baseURL + "/department/update";

export const API_CREATE_DESIGNATION = baseURL + "/designation/create";
export const API_UPDATE_DESIGNATION = baseURL + "/designation/update";

// Biometric
export const API_BIOMETRIC_CREATE = baseURL + "/biometric/mapping/create";
export const API_BIOMETRIC_UPDATE = baseURL + "/biometric/mapping/update";
export const API_BIOMETRIC = baseURL + "/biometric/";

export const API_LEAVE_MANAGER = baseURL + "/user/v1/leave-manager";
export const API_ASSIGN_LEAVE_MANAGER =
  baseURL + "/user/v1/leave-manager/assign";
export const API_REMOVE_LEAVE_MANAGER =
  baseURL + "/user/v1/leave-manager/remove";

// Leave credit request
export const API_LEAVE_CREDIT_REQUEST = baseURL + "/leave-credit/v1/request";
export const API_ADD_LEAVE_CREDIT_REQUEST =
  baseURL + "/leave-credit/v1/request/add";
export const API_WITHDRAWAL_LEAVE_CREDIT_REQUEST =
  baseURL + "/leave-credit/v1/request/withdrawal";
export const API_APPROVE_LEAVE_CREDIT_REQUEST =
  baseURL + "/leave-credit/v1/request/approve";
export const API_REJECT_LEAVE_CREDIT_REQUEST =
  baseURL + "/leave-credit/v1/request/reject";
export const API_GET_PENDING_LEAVE_REQUESTS =
  baseURL + "/leave/getPendingRequest";

// Holiday
export const API_HOLIDAY = baseURL + "/holiday";
export const API_HOLIDAY_ADD = baseURL + "/holiday/add";
export const API_HOLIDAY_UPDATE = baseURL + "/holiday/update";
export const API_HOLIDAY_DELETE = baseURL + "/holiday/delete";

//Regularization
export const API_REGULARIZATION =
  baseURL + "/attendance/regularization/v1/apply";
export const API_REGULARIZATION_GET =
  baseURL + "/attendance/regularization/v1/get";
export const API_REGULARIZATION_WITHDRAW =
  baseURL + "/attendance/regularization/v1/withdraw";

// HR Approval
export const API_REGULARIZATION_HR_APPROVE =
  baseURL + "/attendance/regularization/v1/hr/approve";
export const API_REGULARIZATION_HR_LIST =
  baseURL + "/attendance/regularization/v1/hr";

// Manager Approval
export const API_REGULARIZATION_MANAGER_APPROVE =
  baseURL + "/attendance/regularization/v1/manager/approve";
export const API_REGULARIZATION_MANAGER_LIST =
  baseURL + "/attendance/regularization/v1/manager";

export const API_LEAVE_ATTANDANCE_COMPILE_LIST =
  baseURL + "/leave/emp/attandance/compile";

export const API_DOWNLOAD_ATTENDANCE = baseURL + "/punch/punch-details";

//Project Management

export const API_PROJECT = baseURL + "/project";
export const API_PROJECT_LIST = baseURL + "/project/projects";
export const API_SQE_PROJECT_LIST = baseURL + "/project/sqe-projects";
export const API_PROJECT_TEAM = baseURL + "/project/team-by-project";
export const API_PROJECT_MEMBER_HISTORY =
  baseURL + "/project/member-history/project";
export const API_EDIT_PROJECT_DETAILS = baseURL + "/project/edit-project";
export const API_EDIT_PROJECT_MEMBERS = baseURL + "/project/edit";
export const API_ASSIGN_PROJECT_MEMBERS = baseURL + "/project/assign";
export const API_DELETE_PROJECT_MEMBERS =
  baseURL + "/project/delete-project-member";
export const API_DOWNLOAD_ALL_PROJECTS_REPORT =
  baseURL + "/project/api/projects/export";

export const API_DOWNLOAD_PROJECT_REPORT_BY_PROJECT_ID =
  baseURL + "/project/api/projects";

export const API_DOWNLOAD_PROJECT_REPORT_BY_EMPLOYEE_ID =
  baseURL + "/project/api/projects/employee";

export const API_DOWNLOAD_PROJECT_REPORT_BY_DL_ID =
  baseURL + "/project/api/projects/dl";

export const API_GET_PROJECTS_BY_EMPLOYEE_ID =
  baseURL + "/project/projects-by-employee";

export const API_BULK_CREATE_PROJECT = baseURL + "/project/createBulkProjects";

export const API_GET_PRINCIPAL_SPONSOR_LIST = baseURL + "/project/ps/list";
export const API_GET_PROJECT_MANAGER_LIST = baseURL + "/project/pm/list";
export const API_GET_LEAD_BUSINESS_ANALYST_LIST = baseURL + "/project/lba/list";
export const API_GET_HEAD_OF_DELIVERY_LIST = baseURL + "/project/hod/list";
export const API_GET_PROGRAM_MANAGER_LIST =
  baseURL + "/project/programManager/list";

export const API_GET_PROJECT_SUMMARY_BY_EMPLOYEE_ID =
  baseURL + "/project/project-summary";

export const API_PROJECT_CREATE_NOTIFICATION =
  baseURL + "/project/create/notification";

export const API_PROJECT_COMPLETE_NOTIFICATION =
  baseURL + "/project/complete/notification";

export const API_PROJECT_CLOSED_NOTIFICATION =
  baseURL + "/project/closed/notification";

export const API_PROJECT_HOLD_NOTIFICATION =
  baseURL + "/project/hold/notification";
export const API_GET_ALL_PROJECTS_PROJECTID_AND_PROJECTNAME =
  baseURL + "/project/projects";

export const API_SHADOW_RESOURCES = baseURL + "/project/shadow";
export const API_PROJECT_EXPERTIES = baseURL + "/project/experties";

export const API_GET_SHADOW_RESOURCE_PROJECT_DETAILS_BY_PROJECT_ID =
  baseURL + "/project/shadow/project";

export const API_SHADOW_RESOURCES_REPORTS = baseURL + "/project/api/employees";

export const API_GET_SHADOW_NO_PROJECTS_REPORT = baseURL + "/project/employees";

export const API_GET_SHADOW_EMPLOYEES_LIST =
  baseURL + "/project/getAllShadowMembers";

export const API_GET_MAIN_EMPLOYEE_LIST = baseURL + "/project/getMainMembers";

export const API_GET_PROJECT_MEMBERS_BY_PROJECT_ID =
  baseURL + "/project/by-project";

export const API_CSAT_RATING = baseURL + "/csat";

export const API_GET_PROJECT_DETAIILS =
  baseURL + "/project/getAllProjectDetails";

export const GET_CSAT_PROJECT_DETAILS_BY_PROJECT_ID = baseURL + "/csat/project";

export const GET_ALL_CSAT_PROJECTS_BY_EMPLOYEE_ID = baseURL + "/csat/employee";

export const GET_CSAT_STARS_COUNT = baseURL + "/csat/employee";

export const GET_CSAT_RATINGS_PROJECT_LIST =
  baseURL + "/csat/projects/with-ratings";

// Email Deletion

export const API_ADD_EMAIL_DELETION_REQUEST = baseURL + "/emailDeletion";

export const API_GET_EMAIL_DELETION_USER_DETAILS_BY_EMPLOYEE_ID =
  baseURL + "/emailDeletion/user";

export const API_GET_EMAIL_DELETION_REQUESTS = baseURL + "/emailDeletion";

export const API_UPDATE_EMAIL_DELETION_REQUEST =
  baseURL + "/emailDeletion/approve";

export const API_GET_EMAILDELETION_USERS_LIST = baseURL + "/emailDeletion/user";

export const API_GET_EMPLOYEE_PROFILE_IMAGE = baseURL + "/document/get/profile";

export const API_GET_ACCESS_TYPES = baseURL + "/api/access/types";

export const API_APPROVE_ACCESS_TYPE_REQUEST = baseURL + "/api/access/approve";

export const API_ADD_ACCESS_REQUEST = baseURL + "/api/access/addRequest";

export const API_CREATE_ACCESS_TYPE = baseURL + "/api/access/add/accessRequest";

export const API_GET_ALL_APPROVE_ACCESS_REQUESTS =
  baseURL + "/api/access/getPendingRequests/types";

export const API_APPROVE_ACCESS_REQUEST_DL = baseURL + "/api/access/approve/dl";

export const API_APPROVE_ACCESS_REQUEST_IT = baseURL + "/api/access/approve/it";

export const GET_ALL_REQUESTS_DL = baseURL + "/api/access/requests/dl";

export const GET_ALL_REQUESTS_IT = baseURL + "/api/access/requests/it";

export const API_GET_ALL_ACTIVE_PROJECTS =
  baseURL + "/project/getActiveProjects";

// Assigned Systems

export const API_GET_EMPLOYEES_WITH_ASSIGNED_ASSETS =
  baseURL + "/api/v1/mdm/activity/list/systems";

export const API_GET_ASSIGNED_SYSTEMS_BY_EMPID =
  baseURL + "/api/v1/mdm/activity/employee/system-assets";

export const API_GET_SYSTEM_LOGS = baseURL + "/api/v1/mdm/activity/all";

export const API_GET_SYSTEM_LOGS_BY_EMPID =
  baseURL + "/api/v1/mdm/activity/employee/system-logs";

export const API_BULK_UPLOAD_SYSTEM_LOGS =
  baseURL + "/api/v1/mdm/activity/upload";

export const API_GET_SYSTEM_LOGS_REPORT =
  baseURL + "/api/v1/mdm/activity/system-logs/excel/export";

export const API_IS_SYSTEM_ASSIGNED =
  baseURL + "/api/v1/mdm/activity/is-system-assigned";

export const API_GET_TECHSTACKS_LIST = baseURL + "/user/api/techstack-types";

//Work From Home Timesheet
export const API_GET_TIMESHEET_STATUS = baseURL + "/api/timesheets/status";
export const API_GET_OPEN_TIMESHEET_EMPLOYEES =
  baseURL + "/api/timesheets/timesheet/open";
export const GET_WORK_CATEGORIES = baseURL + "/api/timesheets/work-categories";
export const API_TIMESHEET_PROJECT_CATEGORIES = baseURL + "/api/timesheets/projects";
export const CREATE_WFH_TIMESHEET = baseURL + "/api/timesheets";
export const API_RESUBMIT_WFH_TIMESHEET = baseURL + "/api/timesheets/resubmit";
export const GET_WFH_TIMESHEETS = baseURL + "/api/timesheets";
export const API_SAVE_DRAFT_WFH_TIMESHEET =
  baseURL + "/api/timesheets";
export const API_GET_WFH_TIMESHEET_MANAGER_REQUESTS =
  baseURL + "/api/timesheets/manager/view/timesheets";
export const API_WFH_TIMESHEET_MANAGER_ACTION =
  baseURL + "/api/timesheets/manager/action";
export const API_GET_WFH_TIMESHEETS_REQUESTS_MANAGEMENT_VIEW =
  baseURL + "/api/timesheets/get-all/timesheets";

export const API_GET_TIMESHEETS_PENDING_SUBMITTED =
  baseURL + "/api/timesheets/pending-submitted";

export const API_EXPORT_WFH_TIMEHEETS = baseURL + "/api/timesheets/export";

export const API_GET_WFH_TIMESHEETS_HR_REQUESTS =
  baseURL + "/api/timesheets/hr/timesheets/pending";

export const API_HR_PENDING_EXTENSION_TIMESHEETS =
  baseURL + "/api/timesheet/extension/hr/pending-timesheets";

export const API_EXTEND_DEADLINE = baseURL + "/api/timesheets/extend-deadline";
export const API_TIMESHEET_EXTENSION_REQUEST =
  baseURL + "/api/timesheet/extension/request";
export const API_EXTENSION_REPORT =
  baseURL + "/api/timesheet/extension/extension-report";

export const API_GET_PUNCH_DETAILS_BY_DATE =
  baseURL + "/api/dashboard/today-punch";

export const API_GET_TIMESHEET_WEEKLY_SUMMARY =
  baseURL + "/api/dashboard/weekly-timesheet";

export const API_GET_LEAVE_BALANCE_V2 =
  baseURL + "/api/dashboard/leave-balance";

export const API_GET_CELEBRATIONS_DATA =
  baseURL + "/api/dashboard/celebrations";


export const API_GET_ATTENDANCE_ANALYTICS_DATA =
  baseURL + "/api/dashboard/attendance-analytics";
export const API_GET_ALL_PENDING_ACTION_REQUESTS = baseURL + "/api/dashboard/pending-requests";

export const API_GET_TIMESHEET_STATS = baseURL + "/api/timesheets/stats";
export const API_TIMESHEETS_UTILIZATION_DASHBOARD =
  baseURL + "/api/timesheets/dashboard";


export const API_GET_TIME_ALLOCATED_OVERVIEW =
  baseURL + "/api/timesheets/management/stats";

export const API_GET_PROJECT_UTILIZATION_REPORT =
  baseURL + "/api/project-report/utilization";

export const API_PROJECT_WORKSTREAMS = baseURL + "/project/workstreams";
export const API_PROJECT_WORKSTREAM_TRACKING =
  baseURL + "/api/project-workstream";

export const API_EMPLOYEE_TECH_STACK_LIST =
  baseURL + "/api/employee/tech-stack/list";


export const API_PM_MEMBERS = baseURL + "/api/v2/pm/members";


export const API_V2_ALLOCATIONS = baseURL + "/api/v2/allocations";
export const API_DOWNLOAD_TIMESHEET_REPORT = baseURL + "/api/timesheets/report";
export const API_DOWNLOAD_TIMESHEET_EXCEL = baseURL + "/api/timesheets/report/excel";

export const API_APPROVAL_DASHBOARD =
  baseURL + "/api/timesheets/approval-dashboard";
export const API_APPROVAL_DASHBOARD_EMPLOYEES = (approverId) =>
  `${API_APPROVAL_DASHBOARD}/${approverId}/employees`;
export const API_APPROVAL_DASHBOARD_STATS =
  baseURL + "/api/timesheets/approval-dashboard/stats";
export const API_APPROVAL_DASHBOARD_EXPORT =
  baseURL + "/api/timesheets/approval-dashboard/export";

export const API_AUTH_GENERATE_OTP = baseURL + "/api/auth/generate-otp";
export const SIGN_UP_US = baseURL + "/api/auth/signup/us";
export const PHASE2_GENERATE_OTP = baseURL + "/phase2/generate-otp";
export const PHASE2_VALIDATE = baseURL + "/phase2/validate";
export const PHASE2_SAVE_BANK_DETAILS = baseURL + "/phase2/save-bank-details";
export const PHASE2_UPLOAD_DOCUMENT = baseURL + "/phase2/upload-document";

export function phase2SubmitUrl(employeeId) {
  return `${baseURL}/phase2/submit?employeeId=${encodeURIComponent(String(employeeId))}`;
}

export const API_PHASE2_PENDING_LIST = baseURL + "/phase2/pending-list";

export const API_PHASE2_LIST = baseURL + "/phase2/list";

export function phase2ApproveUrl(employeeId) {
  return `${baseURL}/phase2/approve?employeeId=${encodeURIComponent(String(employeeId))}`;
}

export function phase2RejectUrl(employeeId) {
  return `${baseURL}/phase2/reject?employeeId=${encodeURIComponent(String(employeeId))}`;
}

/** Phase 2 post-join form listing (HR). */
export const API_PHASE2_GET_FORM = baseURL + "/phase2/get/form";

/** Send post-join form invite (empty body). */
export function phase2SendInviteUrl(employeeId) {
  return `${baseURL}/phase2/send?employeeId=${encodeURIComponent(String(employeeId))}`;
}

export const API_OFFBOARDING_MY_REQUEST = baseURL + "/api/offboarding/my-request";

export const API_OFFBOARDING_INITIATE = baseURL + "/api/offboarding/initiate";

export const API_OFFBOARDING_QUESTIONNAIRE = baseURL + "/api/offboarding/questionnaire";

export const API_OFFBOARDING_QUESTIONNAIRE_SUBMIT =
  baseURL + "/api/offboarding/questionnaire/submit";

export const API_OFFBOARDING_WITHDRAW = baseURL + "/api/offboarding/withdraw";

export const API_OFFBOARDING_DETAIL = baseURL + "/api/offboarding";

export const API_OFFBOARDING_LIST = baseURL + "/api/offboarding/list";
export const API_OFFBOARDING_APPROVAL = baseURL + "/api/offboarding/approval";
export const API_OFFBOARDING_TERMINATION = baseURL + "/api/offboarding/termination";

export function offboardingTerminationUrl(employeeId) {
  return `${API_OFFBOARDING_TERMINATION}/${encodeURIComponent(String(employeeId))}`;
}

export const API_OFFBOARDING_PAYROLL_MAIL =
  baseURL + "/api/offboarding/payroll/mail";
export const API_OFFBOARDING_ACKNOWLEDGED = baseURL + "/api/offboarding/acknowledged";
export const API_OFFBOARDING_INSURANCE = baseURL + "/api/employee/offboarding/insurance";

export const API_EMPLOYEE_INSURANCE = baseURL + "/api/employee/insurance";
export const API_EMPLOYEE_INSURANCE_EXISTING =
  baseURL + "/api/employee/insurance/existing";
export const API_HOSPITAL_LIST = baseURL + "/api/hospital/list";
export const API_MY_INSURANCE = baseURL + "/api/my/insurance";
export const API_EMPLOYEE_INSURANCE_STATS =
  baseURL + "/api/employee/insurance/stats";
